// src/pages/AssistancePage/AssistancePage.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Nav from "../../components/Nav/Nav";
import HeroSection from "../../components/HeroSection/HeroSection";
import Footer from "../../components/Footer/Footer";
import LibrexBuilding from "../../assets/images/contacthero.webp";
import ContactForm from "../../components/ContactForm/ContactForm";

const AssistancePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Nav />
      <HeroSection
        title={t("assistance_page.title")}
        subtitle={t("assistance_page.subtitle")}
        backgroundImage={LibrexBuilding}
      />
      <div>
        <ContactForm />
      </div>
      <Footer />
    </>
  );
};

export default AssistancePage;
